declare let process: {
    env: {
        VUE_APP_REDANKA_BE_BASE_URL: string;
        VUE_APP_STAGING_AUTHORITY: string;
        VUE_APP_REDIRECT_URI: string;
        VUE_APP_SILENT_REDIRECT_URI: string;
        VUE_APP_POST_LOGOUT_REDIRECT_URI: string;
        VUE_APP_CLIENT_ID: string;
        VUE_APP_ADMIN_ROLE: string;
        VUE_APP_CLIENT_SECRET: string;
        VUE_APP_ROUTER_BASE: string;
    };
};

export const REDANKA_BE_BASE_URL = process.env.VUE_APP_REDANKA_BE_BASE_URL;
export const STAGING_AUTHORITY = process.env.VUE_APP_STAGING_AUTHORITY;
export const REDIRECT_URI = process.env.VUE_APP_REDIRECT_URI;
export const SILENT_REDIRECT_URI = process.env.VUE_APP_SILENT_REDIRECT_URI;
export const POST_LOGOUT_REDIRECT_URI = process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI;
export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET;
export const ADMIN_ROLE = process.env.VUE_APP_ADMIN_ROLE;
export const ROUTER_BASE = process.env.VUE_APP_ROUTER_BASE;
